import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// The two typefaces of the design system (#406), bundled from npm rather than
// fetched from a font host: index.html makes no third-party request, and the
// fonts are no exception. The Latin subset only -- every word on these screens
// is Portuguese -- and only the weights global.css uses. Each import is one
// woff2 Vite copies into the build; none of them is JavaScript.
import '@fontsource/plus-jakarta-sans/latin-400.css';
import '@fontsource/plus-jakarta-sans/latin-600.css';
import '@fontsource/plus-jakarta-sans/latin-700.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';
import '@fontsource/jetbrains-mono/latin-700.css';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('index.html precisa conter <div id="root">.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
